<style>
  .inventoryTable .el-input__inner {
    text-align: center;
  }

  .inventoryTable .item-checkbox .el-form-item__content {
    padding-top: 6px;
  }

  .form-group .inventoryTable .el-form-item {
    margin-top: 11px !important;
  }

  .max-dispensable-invalid input {
    border-color: #d3a429;
  }

  .max-dispensable-invalid input:focus {
    border-color: #d3a429;
  }
</style>

<template>
  <div>
    <el-table :data="filteredAcceptableMaterials()" class="inventoryTable" style="width: 100%;">
      <el-table-column :label="$t('management.unit.softwaresettings.inventorypanel.denomination')" min-width="15%" align="center">
        <template slot-scope="scope">
          <span>{{ parseFloat(scope.row.denomination.value).toFixed(2) }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('management.unit.softwaresettings.inventorypanel.material')" min-width="10%" align="center">
        <template slot-scope="scope">
          <span>{{ $t('management.unit.softwaresettings.inventorypanel.' + scope.row.denomination.material) }}</span>
        </template>
      </el-table-column>

      <el-table-column v-if="hasRecycler" :label="$t('management.unit.softwaresettings.inventorypanel.recycled')" min-width="10%" align="center">
        <template slot-scope="scope">
          <el-form-item class="item-checkbox">
            <el-checkbox v-model="scope.row.recycled" :checked="scope.recycled" @change="updateSettings()" :disabled="!overridden || readOnly"></el-checkbox>
          </el-form-item>
        </template>
      </el-table-column>

      <el-table-column v-if="hasMinAmount" :label="$t('management.unit.softwaresettings.inventorypanel.min')" min-width="15%" align="center">
        <template slot-scope="scope">
          <el-form-item class="custom-label">
            <el-input v-model="scope.row.minAmount" type="number" @change="updateSettings()" :disabled="!overridden || readOnly"></el-input>
          </el-form-item>
        </template>
      </el-table-column>

       <el-table-column v-if="hasLowAmount" :label="$t('management.unit.softwaresettings.inventorypanel.low')" min-width="15%" align="center">
        <template slot-scope="scope">
          <el-form-item class="custom-label">
            <el-input v-model="scope.row.lowAmount" type="number" min="0" @change="updateSettings()" :disabled="!overridden || readOnly"></el-input>
          </el-form-item>
        </template>
      </el-table-column>

      <el-table-column :label="$t('management.unit.softwaresettings.inventorypanel.optimum')" min-width="15%" align="center">
        <template slot-scope="scope">
          <el-form-item class="custom-label">
            <el-input v-model="scope.row.optimumAmount" type="number" min="0" @change="updateSettings()" :disabled="!overridden || readOnly"></el-input>
          </el-form-item>
        </template>
      </el-table-column>

      <el-table-column v-if="!hasLowAmount && hasMaxAmount" :label="$t('management.unit.softwaresettings.inventorypanel.max')" min-width="15%" align="center">
        <template slot-scope="scope">
          <el-form-item class="custom-label">
            <el-input v-model="scope.row.maxAmount" type="number" min="0" @change="updateSettings()" :disabled="!overridden || readOnly"></el-input>
          </el-form-item>
        </template>
      </el-table-column>

      <el-table-column v-if="hasHightAmount" :label="$t('management.unit.softwaresettings.inventorypanel.high')" min-width="15%" align="center">
        <template slot-scope="scope">
          <el-form-item class="custom-label">
            <el-input v-model="scope.row.highAmount" type="number" min="0" @change="updateSettings()" :disabled="!overridden || readOnly"></el-input>
          </el-form-item>
        </template>
      </el-table-column>

      <el-table-column v-if="valueColumn" :label="$t('management.unit.softwaresettings.inventorypanel.value')" min-width="15%" align="center">
        <template slot-scope="scope">
          <el-form-item class="custom-label">
            <el-input v-model="scope.row.value" type="number" min="0" @change="updateSettings()" :disabled="!overridden || readOnly"></el-input>
          </el-form-item>
        </template>
      </el-table-column>

      <el-table-column v-if="maxDispensableColumn" :label="$t('management.unit.softwaresettings.inventorypanel.maxDispensable')" min-width="15%" align="center">
        <template slot-scope="scope">
          <el-form-item class="custom-label" v-if="scope.row.denomination.material === 'COIN'">
            <el-input :class="{'max-dispensable-invalid': isInvalid(scope.row)}" v-model="scope.row.maxDispensable" type="number" min="0" :max="getMaxDispensable(scope.row.denomination.value, scope.row.denomination.material)"  @change="updateSettings(scope.row, 'maxDispensable')" :disabled="!overridden || readOnly"></el-input>
          </el-form-item>
        </template>
      </el-table-column>
    </el-table>

    <div v-if="nonRecyleableMaterials().length" style="width: 400px;">
      <h4 style="margin-bottom: 0">{{ $t('management.unit.softwaresettings.inventorypanel.nonRecyclable') }}</h4>
      <el-table  :data="nonRecyleableMaterials()" style="width: auto;">
        <el-table-column :label="$t('management.unit.softwaresettings.inventorypanel.denomination')" min-width="15%" align="center">
          <template slot-scope="scope">
            <span>{{ parseFloat(scope.row.denomination.value).toFixed(2) }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('management.unit.softwaresettings.inventorypanel.material')" min-width="10%" align="center">
          <template slot-scope="scope">
            <span>{{ $t('management.unit.softwaresettings.inventorypanel.' + scope.row.denomination.material) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>

  import Vue from 'vue'

  const excludedPlaceholders = ['om61']

  export default {
    name: 'DqInventorypanel',
    replace: true,
    props: {
      label: '',
      valueColumn: true,
      maxDispensableColumn: true,
      overridden: false,
      acceptableMaterials: [],
      readOnly: false
    },
    data: function () {
      return {
        inventorySettingsNew: [...this.acceptableMaterials],
        maxValues: {
          '0.01': 200,
          '0.02': 200,
          '0.05': 200,
          '0.1': 200,
          '0.2': 140,
          '0.5': 115,
          '1.0': 130,
          '1.00': 130,
          '2.0': 100,
          '2.00': 100
        }
      }
    },
    computed: {
      hasMaxDispensable () {
        return this.acceptableMaterials.some(row => 'maxDispensable' in row)
      },
      hasRecycler () {
        return this.acceptableMaterials.some(row => 'recycled' in row)
      },
      hasMaxAmount () {
        return this.acceptableMaterials.some(row => 'maxAmount' in row)
      },
      hasHightAmount () {
        return this.acceptableMaterials.some(row => 'highAmount' in row)
      },
      hasMinAmount () {
        return this.acceptableMaterials.some(row => 'minAmount' in row)
      },
      hasLowAmount () {
        return this.acceptableMaterials.some(row => 'lowAmount' in row)
      }
    },
    mounted () {
      this.updateSettings()
    },
    watch: {
      inventorySettings: function () {
        this.updateSettings()
      }
    },
    methods: {
      filteredAcceptableMaterials () {
        return this.acceptableMaterials.filter(m => !excludedPlaceholders.includes(m.placeholder) && !this.isNonRecyclableDollarCoin(m))
      },
      nonRecyleableMaterials () {
        return this.acceptableMaterials.filter(m => !excludedPlaceholders.includes(m.placeholder) && this.isNonRecyclableDollarCoin(m))
      },
      updateSettings (row, field) {
        this.inventorySettingsNew = [...this.acceptableMaterials]
        this.$store.commit('overrideInventorySettings/setOverrideInventorySettings', { inventorySettings: this.inventorySettingsNew })

        // Check if maxDispensable is higher than maxDispensableAmountForDrawer
        if (this.maxDispensableColumn) {
          this.validateMaxDispensableColumn(row, field)
        }
      },
      validateMaxDispensableColumn (row, field) {
        let inventoryValid = true
        this.acceptableMaterials.forEach(material => {
          if (material === row && field === 'maxDispensable') {
            if (material.maxDispensable > material.maxDispensableAmountForDrawer) {
              this.$message.error({message: Vue.t('management.unit.softwaresettings.inventorypanel.messages.excideMaximumDrawer',
              {limit: material.maxDispensableAmountForDrawer})})
              inventoryValid = false
            } else if (material.maxDispensable > material.maxDispensableAmountForCup) {
              this.$message.warning({message: Vue.t('management.unit.softwaresettings.inventorypanel.messages.excideMaximumCup',
              {limit: material.maxDispensableAmountForCup})})
            }
          }
        })
        inventoryValid = this.checkAllMaxDispensableValidity()
        this.$emit('setInventoryValid', inventoryValid)
      },
      checkAllMaxDispensableValidity () {
        return this.acceptableMaterials.every(material => {
          if (material.maxDispensable !== undefined && material.maxDispensableAmountForDrawer !== undefined) {
            return material.maxDispensable <= material.maxDispensableAmountForDrawer
          }
          return true
        }
        )
      },
      getMaxDispensable (denomination, material) {
        const materialItem = this.acceptableMaterials.find(item => item.denomination.value === denomination && item.denomination.material === material)

        if (materialItem.maxDispensableAmountForDrawer) {
          return materialItem.maxDispensableAmountForDrawer
        }

        return this.maxValues[denomination] || 100
      },
      isInvalid (row) {
        return row.maxDispensable > row.maxDispensableAmountForDrawer
      },
      isNonRecyclableDollarCoin (row) {
        const { material, currency, value } = row.denomination
        return material === 'COIN' && currency === 'USD' && value >= 0.5
      }
    }
  }
</script>



// WEBPACK FOOTER //
// inventorypanel.vue?d5ae1d5c